<template lang="pug">
v-main
  v-container(fluid)
    v-dialog(v-model="approvalDialog" persistent max-width="400px")
      v-card()
        v-card-text
          v-layout(wrap)
            div(style="text-align: center; width: 100%; padding: 2rem; padding-bottom:0")
              v-icon(style="color:#FB8C00;font-size: 42px;padding: 1rem;") send
              p(style="color:#000000;font-size: 24px;") Are you sure?
              p(style="color:#00000099;font-size: 16px;") Do you really want to resend memo? Memo can only be resent once per day
        v-card-actions
          v-spacer
          div(style="width: 100%;display: flex;justify-content: space-between;padding: 1rem 3rem;")
            v-btn(style="flex: 1" @click.native="approvalDialog = false;").mr-1 No
            v-btn(@click="approvalDialog = false; approvalDialog2 = true; overlay = true; confirmResend()" style="flex: 1; background-color: #1976D2; color:white;margin-left:3rem") Yes
          div(class="text-xs-center")
            v-dialog(
              v-model="approvalDialog2"
              hide-overlay
              persistent
              width="300")
              v-card(color="primary" dark)
                v-card-text(style="padding:1.3rem") Processing. Please wait!
                  v-progress-linear(indeterminate color="white" class="mb-0")
    v-card(style="padding: 1rem; border-radius: 0")
      div
        p(style="font-weight: 400; font-size:24px; margin-bottom:0") Resend Page
    v-card(style="padding: 1rem; border-radius: 0")
      div(style="background-color:  rgba(76, 175, 80, 0.12); padding: .5rem; border-radius: 5px;")
        p(style="margin:0 ;font-weight: 400; font-size:14px; color: #555555; margin-top: 0.2rem;color: #4CAF50;") Notes:
        ul(style="margin:0 ;font-weight: 400; font-size:14px;color: #4CAF50;")
          li Resending a memo for the same approval can only once a day
          li Resend memo only for memo with status&nbsp;
            b 'On Approval' 
            | and 
            b 'Need Review’
          li Memo only related to business units can be searched.

    v-card(style="padding: 1rem; border-radius: 0; padding-bottom: 0")
      .pb-1

        div(style="display: flex")

          v-text-field.pt-0(
            maxlength="17"
            outlined
            :class="{ wrongSearch: wrongSearch}"
            class="textboxes"
            v-model="searchImNoText",
            required,
            @keyup.enter="getData"
            :hint="wrongSearch ? 'The number is incomplete (16 digits required - eg. IM-BU01-12345678).': '16 digits required - eg. IM-BU01-12345678.'",
            label="Search IM Number"
          )
            template(
              v-slot:append
              style="margin:0 !Important"
            )
              v-btn(
                style="background: white; box-shadow: none; min-width: 50px; width: 50px; height: 50px",
                @click="getData"
              )
                v-icon fas fa-search

    v-card(style="padding: 1rem; border-radius: 0")
      v-card.card-contact(
        elevation="0",
        v-show="items.length == 0 && dataFound",
        style="margin: 0; min-width=320px; background:#fff !important", 
      ) 
        div(style="margin: auto; width: 50%; padding: 1rem;")
          p(style="text-align: center")
            v-icon(style="font-size: 59px;") fas fa-search
          p(style="text-align: center; font-size:16px; color: #667085") Please search your IM Number
      
      v-card.card-contact(
        elevation="0",
        v-show="items.length == 0 && !dataFound",
        style="margin: 0; min-width=320px; background:#fff !important", 
      )
        div(style="margin: auto; width: 50%; padding: 1rem;")
          p(style="text-align: center")
            v-icon(style="font-size: 59px;") fas fa-search
          p(style="font-weight:600; font-size:16px ;margin:0;text-align: center; font-size:16px; color: #000") No Results Found
          div(style="max-width: 350px; margin: auto;")
            h2(style="font-weight:400; font-size:14px ;text-align: left; font-size:16px; color: #667085; margin-bottom:0;") Make sure your search meet following criteria:
            ul
              li(style="font-weight:400; font-size:14px ;text-align: left; font-size:16px; color: #667085; margin-bottom:0;" ) You are an admin of the memo BU
              li(style="font-weight:400; font-size:14px ;text-align: left; font-size:16px; color: #667085; margin-bottom:0;" ) Memo is in following status: "On Approval" or "Need Approval" or "Need Review"

      v-data-table.elevation-1(
        v-show="items.length > 0"
        :headers="headers"
        :items="items"
        :hide-default-footer="true"

      )
        template(v-slot:item.actions='{ item }')
          template
            v-btn(:disabled="!item.enabledResend" :color="info" style= "background-color:#FFC700 !important" @click="approvalDialog = true")
              v-icon send
              | &nbsp; Resend

  v-overlay(:value="overlay")
    v-progress-circular(indeterminate, size="64")
</template>

  <script>
import axios from "axios";
export default {
  name: "Contact",
  data() {
    return {
      headers: [
        {
          text: "IM Number",
          value: "imNo"
        },
        {
          text: "Subject",
          value: "imPerihalHashed"
        },
        {
          text: "Action",
          value: "actions",
          align: "center"
        }
      ],
      items: [],
      approvalDialog: false,
      approvalDialog2: false,
      wrongSearch: false,
      dataFound: true,
      searchImNoText: "",
      overlay: false,
    };
  },
  methods: {
    confirmResend() {
      this.$store
        .dispatch("resendNotif", { imNo: this.searchImNoText })
        .then((res) => {
          if (res.data.status == 403) this.$toasted.error("Cannot resend notification to creator", { icon : 'error'});
          else  this.$toasted.success("Success, Memo has been resent.", { icon : 'check_circle'});
          this.approvalDialog2 = false
          this.overlay = false
          this.getData()
        }).catch((err) => {
            this.$toasted.error(err.response.error, { icon: 'error' });
            this.approvalDialog2 = false
            this.overlay = false
            //- location.reload();
        });
    },
    getData() {
      this.searchImNoText = this.searchImNoText.trim()
      this.items = [];
      this.wrongSearch = false;
      if (this.searchImNoText.length == 16 || this.searchImNoText.length == 17) {
        this.overlay = true;
        axios
          .get(
            `${process.env.VUE_APP_API_OLD}/api/v2/requests/${this.searchImNoText}`, {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
              }
            }
          )
          .then((res) => {
            this.overlay = false;
            this.items.push(res.data)
            if (res.data.length > 0) {
              this.dataFound = true;
            } else this.dataFound = false;
          })
          .catch((err) => {
            this.dataFound = false;
            this.overlay = false;
          })
          .finally(() => {
            this.overlay = false;
            this.loading = false;
          });
      } else this.wrongSearch = true;
    },
  },
  watch: {
    searchImNoText: {
      handler: function () {
        if (this.searchImNoText.length >= 5) this.wrongSearch = false;
      },
      deep: true,
    },
  },
};
</script>

  <style>
.v-toolbar__content {
  box-shadow: none;
}

.contact-padding {
  padding: 2rem;
}

.card-contact-first {
  margin: 1.5rem;
  background: #f7f7f7 !important;
}

.card-contact {
  background: #f7f7f7 !important;
  padding: 2rem;
  margin: 1.5rem;
}

.title-contact {
  font-size: 24px;
  color: #121212;
  font-weight: 500;
}

.subtitle-contact {
  font-size: 16px;
  color: #555555;
  margin-top: 0.4rem;
}

.img-contact {
  height: 160px;
  width: auto;
}
.textboxes div div div.v-input__append-inner {
  margin-top: 2px !important;
}

.textboxes div .v-text-field__details {
  margin: 0px !important;
}

.wrongSearch fieldset {
  color: red !important;
}

.wrongSearch label {
  color: red !important;
}

.wrongSearch div div .primary--text {
  color: red !important;
}

.wrongSearch div div input {
  color: red !important;
}

.wrongSearch div .v-text-field__details div div {
  color: red;
}
</style>